import styles from "../../../../styles/Participant-Employment.module.css"
import { Button } from "primereact/button"
import ContactForm from "../ContactForm"
import { deleteConfirmationModal } from "../../Utils/formikAux"
import { careerProfileLabels } from "../../Types/careerProfileLabels"
import EditorField from "../../Utils/EditorField"
const NetworkingContacts = ({
  setContactFormVisible,
  contactFormVisible,
  editContact,
  formik,
  setEditContact,
  setDeleteContact,
  deleteContact,
}) => {
  const contactsTable = () => {
    return (
      <table
        className={styles.table}
        style={{
          marginBottom: "1rem",
          paddingTop: "17px",
          paddingLeft: "16px",
          paddingBottom: "23px",
          paddingRight: "15px",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "19px",
              }}
            >
              Name
            </th>
            <th
              style={{
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "19px",
              }}
            >
              Contact type
            </th>
          </tr>
        </thead>
        <tbody>
          {formik.values.networking_contacts.map((e) => {
            return (
              <tr key={e.name}>
                <td>{e.name}</td>
                <td>{e.type}</td>
                <td
                  style={{
                    textAlign: "center",
                    width: "80px",
                    paddingRight: "1rem",
                  }}
                >
                  {
                    <div className={styles.table_actions}>
                      <Button
                        icon="pi pi-pencil"
                        className={styles.rounded_btn}
                        type="button"
                        onClick={() => {
                          setEditContact(e)
                          setContactFormVisible(true)
                        }}
                      />
                      <Button
                        icon="pi pi-trash"
                        className={styles.rounded_btn}
                        type="button"
                        onClick={() => {
                          setDeleteContact(e.id)
                        }}
                      />
                    </div>
                  }
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }
  const removeContact = (id) => {
    formik.setFieldValue(
      "networking_contacts",
      formik.values.networking_contacts.filter((p) => p.id !== id)
    )
  }
  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <label
          style={{
            paddingTop: "10px",
            fontSize: "16px",
            fontWeight: "600",
            lineHeight: "22px",
            color: "#383838",
          }}
        >
          Networking contacts
        </label>
        <Button
          label="Add new contact"
          onClick={() => setContactFormVisible(true)}
          style={{ width: "150px", marginBottom: "1rem", height: "38px" }}
          type="button"
          className={styles.button}
        />
      </div>

      <ContactForm
        setVisible={setContactFormVisible}
        visible={contactFormVisible}
        edit={editContact}
        setEdit={setEditContact}
        setValue={formik.setFieldValue}
        contacts={formik.values.networking_contacts}
      />
      {formik.values.networking_contacts?.length > 0 && contactsTable()}
      {deleteConfirmationModal(
        deleteContact,
        setDeleteContact,
        removeContact,
        "networking contact"
      )}
      <div style={{ marginTop: "20px" }}>
        <EditorField
          label={
            careerProfileLabels.networkingContacts.networkingContacts_1.label
          }
          value={formik.values.networking_1}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.networkingContacts.networkingContacts_1.value
          }
        />
      </div>
    </>
  )
}
export default NetworkingContacts
